import React, { useState, useEffect } from 'react';
import {
  Card, CardHeader, Row, Col, Badge, CardBody, Tooltip
} from 'reactstrap'
import { Bar } from 'react-chartjs-2'


const horas   = ['00h','01h','02h','03h','04h','05h','06h','07h','08h','09h','10h','11h','12h','13h','14h','15h','16h','17h','18h','19h','20h','21h','22h','23h'];
const valores = ['1','1','1','1','1','1','1','1','1','1','1','1','1','1','1','1','1','1','1','1','1','1','1','1'];
const options = {
  responsive: true,
  legend: {
    display: false,
    position: 'top'
  },
  plugins: {
    legend: {
      display: false,
      position: 'top',
    },
    title: {
      display: false,
      text: 'Demostrativo de vendas por hora',
    },

  },
  tooltips: {
    enabled: false,
  },
  scales: {
    yAxes: [
      {
        ticks: {
          display: false,
        },
        gridLines: {
          display: false,
          drawBorder: false,
          zeroLineColor: "transparent",
          color: "rgba(85,255,66,0.2)"
        },
        grid: {
          display: false, // Hide x grid
        }
      }
    ],
    xAxes: [
      {
        barPercentage: 1.2,
        gridLines: {
          display: false,
          drawBorder: false,
          color: "rgba(255,255,255,0.1)",
          zeroLineColor: "transparent"
        },
        ticks: {
          display: true
        },
        grid: {
          display: false, // Hide x grid
        },
      }
    ]
  }
};

const LinhaCard = ({ dia, color, lista })  => {

  const [dadosLinha, setDadosLinha] = useState([])
  const [tooltipGrafico, setTooltipGrafico] = useState(false)

  // const rtLinha = listaDados[dia].map((valor, hora)=> (valor / 300) * 100)
  // let diaLinha = []
  // rtLinha.horas.map((item, key) => 
  //  diaLinha.push(formatarCor(item))
  // )

  const formatarCor = (hora) =>{
    if (hora <= 0) {
      return ('#bdc3c7')
    }

    let porcentagem = (hora/lista.total)*100

    if (porcentagem <= 5) {
      return ('#5cb85c')
    }

    if (porcentagem <= 10) {
      return ('#f1c40f')
    }

    if (porcentagem > 10) {
      return ('#c0392b')
    }
  }

  const preencherDados = () =>{
    let diaLinha = []
    let dadosHoras = lista.horas


    if (Array.isArray(dadosHoras) && dadosHoras.length) {
      for (let i = 0; i < dadosHoras.length; i++) {
        diaLinha.push(formatarCor(dadosHoras[i].valor))
      }
    }

    setDadosLinha(diaLinha)
  }

  useEffect(() => {
    preencherDados()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    preencherDados()
  }, [lista,dia]) // eslint-disable-line react-hooks/exhaustive-deps

  // fazer por porcentagem
  // pegar o valor da hora, divido pelo total vezes 100
  // depois criar um padrão manual para receber as cores

  let dtset = [];

  dtset.push({
            data: valores,
            backgroundColor: dadosLinha
        })

  var data = {
    labels: horas,
    datasets:dtset
  };

  return (
    <Card>
      <CardHeader>
        <Row>
          <Col sm="7">
            {/* <div className="numbers pull-left grafico-valor"><Monetario valor={560}/></div> */}
            <div className="numbers pull-left grafico-valor">{(lista.data)?lista.data+' - '+dia:"Nenhum movimento"}</div>
          </Col>
          <Col sm="5">
            <div className="pull-right">
              <Badge className="text-blue" pill>
                Pico de atendimento diário
              </Badge>
            </div>
          </Col>
        </Row>
      </CardHeader>
      <div id='tooltip' 
        onMouseEnter={()=>{setTooltipGrafico(true)}}
        onMouseLeave={()=>{setTooltipGrafico(false)}}
      >
        <Tooltip placement="top" isOpen={tooltipGrafico} target="tooltip" >
          Clique em um dia da semana acima
        </Tooltip>
        <CardBody>
          <Bar
            data={data}
            options={options}
            width={550}
            height={50}
          />
        </CardBody>

      </div>
    </Card>
  )
}

export default LinhaCard
